import styled from '@emotion/styled';
import { PRIMARY_COLOR } from '@core/colors';

export const LoadingInlineStyled = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.6);
  .lds-ring {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 50px;
      height: 50px;
      margin: 8px;
      border: 4px solid ${PRIMARY_COLOR};
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: ${PRIMARY_COLOR} transparent transparent transparent;
    }
    div:nth-of-type(1) {
      animation-delay: -0.45s;
    }
    div:nth-of-type(2) {
      animation-delay: -0.3s;
    }
    div:nth-of-type(3) {
      animation-delay: -0.15s;
    }
    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
`;

export const LoadingFullScreenStyled = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  content: '';
  z-index: 10000 !important;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.6);
  .lds-facebook {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    z-index: 10000 !important;
  }
  .lds-facebook div {
    display: inline-block;
    position: absolute;
    left: 8px;
    width: 16px;
    background: #f8bd40;
    animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  }
  .lds-facebook div:nth-of-type(1) {
    left: 8px;
    animation-delay: -0.24s;
  }
  .lds-facebook div:nth-of-type(2) {
    left: 32px;
    animation-delay: -0.12s;
  }
  .lds-facebook div:nth-of-type(3) {
    left: 56px;
    animation-delay: 0;
  }
  @keyframes lds-facebook {
    0% {
      top: 8px;
      height: 64px;
    }
    50%,
    100% {
      top: 24px;
      height: 32px;
    }
  }
`;

export const LoadingFullScreenDialogStyled = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000 !important;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.6);
  .lds-ring {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 50px;
      height: 50px;
      margin: 8px;
      border: 4px solid ${PRIMARY_COLOR};
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: ${PRIMARY_COLOR} transparent transparent transparent;
    }
    div:nth-of-type(1) {
      animation-delay: -0.45s;
    }
    div:nth-of-type(2) {
      animation-delay: -0.3s;
    }
    div:nth-of-type(3) {
      animation-delay: -0.15s;
    }
    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
`;

export const LoadingInlineSmallStyled = styled.div`
  position: relative;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.6);
  margin: auto;
  .lds-ring {
    display: inline-block;
    position: relative;
    width: 30px;
    height: 30px;
    margin: auto;
    div {
      margin: auto;
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 30px;
      height: 30px;
      border: 4px solid ${PRIMARY_COLOR};
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: ${PRIMARY_COLOR} transparent transparent transparent;
    }
    div:nth-of-type(1) {
      animation-delay: -0.45s;
    }
    div:nth-of-type(2) {
      animation-delay: -0.3s;
    }
    div:nth-of-type(3) {
      animation-delay: -0.15s;
    }
    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
`;
